import {
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: 1.15,
  [theme.breakpoints.down("sm")]:{
    fontSize: "1.5rem"
  }
}));

export const TitleTypographyVideo = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: 1.15,
  [theme.breakpoints.down("sm")]:{
    fontSize: "0.7rem",
    fontWeight: 500
  }
}));
